import React from 'react';
import { Grid, Input } from 'semantic-ui-react';

export default function DateTimeComponent({ value, onChange, disabled, onBlur, name, index }) {
  const dateTimeValue = value || { date: '', time: '' };
  const componentName = name || '';

  const onDateChange = (e) => {
    const newDateTimeValue = { ...dateTimeValue, date: e.target.value, componentName, index };
    onChange(newDateTimeValue);
  };

  const onTimeChange = (e) => {
    const newDateTimeValue = { ...dateTimeValue, time: e.target.value, componentName, index };
    onChange(newDateTimeValue);
  };

  const { date, time } = dateTimeValue;

  return (
    <div>
      <Grid columns={2} doubling>
        <Grid.Column>
          <Input type="date" onChange={onDateChange} onBlur={onBlur} value={date} disabled={disabled} />
        </Grid.Column>
        <Grid.Column>
          <Input type="time" onChange={onTimeChange} onBlur={onBlur} value={time} disabled={disabled} />
        </Grid.Column>
      </Grid>
    </div>
  );
}
